/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: wboCjrKjkicgLwUG7d8r4V
// Component: uHY7fCWscEWp

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Slider from "../../Slider"; // plasmic-import: hUj3p_nxMlj8/component
import SliderThumb from "../../SliderThumb"; // plasmic-import: l_wzc3zTP070/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicCreditSlider.module.css"; // plasmic-import: uHY7fCWscEWp/css

createPlasmicElementProxy;

export type PlasmicCreditSlider__VariantMembers = {};
export type PlasmicCreditSlider__VariantsArgs = {};
type VariantPropType = keyof PlasmicCreditSlider__VariantsArgs;
export const PlasmicCreditSlider__VariantProps = new Array<VariantPropType>();

export type PlasmicCreditSlider__ArgsType = {
  onSliderValueChange?: (val: number) => void;
};
type ArgPropType = keyof PlasmicCreditSlider__ArgsType;
export const PlasmicCreditSlider__ArgProps = new Array<ArgPropType>(
  "onSliderValueChange"
);

export type PlasmicCreditSlider__OverridesType = {
  slider?: Flex__<typeof Slider>;
  text?: Flex__<"div">;
  sliderThumb?: Flex__<typeof SliderThumb>;
};

export interface DefaultCreditSliderProps {
  onSliderValueChange?: (val: number) => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicCreditSlider__RenderFunc(props: {
  variants: PlasmicCreditSlider__VariantsArgs;
  args: PlasmicCreditSlider__ArgsType;
  overrides: PlasmicCreditSlider__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "slider.value",
        type: "readonly",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 17000,

        onChangeProp: "onSliderValueChange"
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <Slider
      data-plasmic-name={"slider"}
      data-plasmic-override={overrides.slider}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames("__wab_instance", sty.slider)}
      label={
        <div
          data-plasmic-name={"text"}
          data-plasmic-override={overrides.text}
          className={classNames("all", "__wab_text", sty.text)}
        >
          {"Chci si p\u016fj\u010dit"}
        </div>
      }
      maxValue={30000}
      minValue={1000}
      onChange={async (...eventArgs: any) => {
        generateStateOnChangeProp($state, ["slider", "value"]).apply(
          null,
          eventArgs
        );

        if (
          eventArgs.length > 1 &&
          eventArgs[1] &&
          eventArgs[1]._plasmic_state_init_
        ) {
          return;
        }
      }}
      step={1000}
      thumbs={
        <SliderThumb
          data-plasmic-name={"sliderThumb"}
          data-plasmic-override={overrides.sliderThumb}
          className={classNames("__wab_instance", sty.sliderThumb)}
        />
      }
      value={generateStateValueProp($state, ["slider", "value"])}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  slider: ["slider", "text", "sliderThumb"],
  text: ["text"],
  sliderThumb: ["sliderThumb"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  slider: typeof Slider;
  text: "div";
  sliderThumb: typeof SliderThumb;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCreditSlider__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCreditSlider__VariantsArgs;
    args?: PlasmicCreditSlider__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicCreditSlider__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCreditSlider__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCreditSlider__ArgProps,
          internalVariantPropNames: PlasmicCreditSlider__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCreditSlider__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "slider") {
    func.displayName = "PlasmicCreditSlider";
  } else {
    func.displayName = `PlasmicCreditSlider.${nodeName}`;
  }
  return func;
}

export const PlasmicCreditSlider = Object.assign(
  // Top-level PlasmicCreditSlider renders the root element
  makeNodeComponent("slider"),
  {
    // Helper components rendering sub-elements
    text: makeNodeComponent("text"),
    sliderThumb: makeNodeComponent("sliderThumb"),

    // Metadata about props expected for PlasmicCreditSlider
    internalVariantProps: PlasmicCreditSlider__VariantProps,
    internalArgProps: PlasmicCreditSlider__ArgProps
  }
);

export default PlasmicCreditSlider;
/* prettier-ignore-end */
